var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-Box",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.21 0.331l-9.752 3.662c-0.877 0.329-1.458 1.174-1.458 2.113v10.569c0 0.855 0.483 1.634 1.242 2.014l9.752 4.883c0.633 0.319 1.378 0.319 2.011 0l9.752-4.883c0.764-0.38 1.242-1.164 1.242-2.014v-10.569c0-0.939-0.581-1.78-1.458-2.108l-9.752-3.662c-0.506-0.197-1.069-0.197-1.58-0.005zM12.002 3.247l9.002 3.381v0.052l-9.002 3.662-9.002-3.662v-0.052l9.002-3.381zM13.503 19.962v-6.991l7.501-3.052v6.287l-7.501 3.756z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBox);
export default __webpack_public_path__ + "static/media/box.33505267ccb74e4e6af9a374356c52b2.svg";
export { ForwardRef as ReactComponent };